import { rootStore } from "@/app/model/rootStore";
import { RootStoreContext } from "@/app/model/RootStoreContext";

interface IProps {
  children: React.ReactNode;
}

const RootStoreProvider = ({ children }: IProps) => (
  <RootStoreContext value={rootStore}>{children}</RootStoreContext>
);

export default RootStoreProvider;
